module.exports = __webpack_public_path__ + "img/PODRIA.beeaee30.png";